import { MetricCardProps } from "../../../pages/cdp/types";

export const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  change,
  icon,
  isActive,
  onClick,
  clickable = true,
}) => (
  <div 
    className={`bg-white rounded-lg border ${isActive ? 'border-blue-500' : 'border-gray-200'} p-6 hover:shadow-md transition-shadow ${clickable ? 'cursor-pointer' : 'cursor-default'}`}
    onClick={onClick}
  >
    <div className="flex items-center justify-between mb-4">
      <div className="text-gray-600 text-sm font-medium">{title}</div>
      <div className={`${isActive ? 'text-blue-500' : 'text-gray-400'}`}>{icon}</div>
    </div>
    <div className="text-2xl font-bold text-gray-900 mb-1">{value}</div>
    <div className="text-sm text-green-600 font-medium">{change}</div>
  </div>
);